import React from "react";
import Slider from "react-slick";

const Testimonials = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 6000,
    arrows: true,
  };

  const testimonials = [
    {
      name: "Mr. Arjun Sharma",
      role: "Business Owner",
      image: "assets/images/testimonials/testimonial-2-1.jpg",
      quote:
        "I recently used Lotus Cab for my airport transfer, and the ride was smooth and punctual.",
    },
    {
      name: "Miss. Priya Verma",
      role: "Software Engineer",
      image: "assets/images/testimonials/testimonial-2-2.jpg",
      quote:
        "Lotus Cab's drivers are professional and the service is highly reliable. Highly recommended!",
    },
    {
      name: "Mr. Rohan Mehta",
      role: "Entrepreneur",
      image: "assets/images/testimonials/testimonial-2-3.jpg",
      quote:
        "Booking a ride with Lotus Cab was effortless. Comfortable cars and friendly drivers made my trip enjoyable.",
    },
    {
      name: "Miss. Ananya Reddy",
      role: "Student",
      image: "assets/images/testimonials/testimonial-2-4.jpg",
      quote:
        "I love how easy it is to book a cab with Lotus Cab. The drivers are courteous and punctual.",
    },
  ];

  return (
    <section className="testimonials-two" id="testimonials">
      <div className="container">
        <div className="row gutter-y-50 align-items-center">

          {/* LEFT CONTENT */}
          <div className="col-xl-6">
            <div className="testimonials-two__content">
              <div className="sec-title">
                <div className="sec-title__top">
                  <div className="sec-title__shape"></div>
                  <h6 className="sec-title__tagline">
                    Our Testimonials
                  </h6>
                </div>
                <h3 className="sec-title__title">
                  People Talk About <br /> Lotus Cab Service
                </h3>
              </div>
            </div>
          </div>

          {/* RIGHT SLIDER */}
          <div className="col-xl-6">
            <Slider {...settings}>

              {testimonials.map((item, index) => (
                <div key={index}>
                  <div className="testimonial-card-two">
                    <div className="testimonial-card-two__inner">

                      <div className="testimonial-card-two__top">
                        <div className="testimonial-card-two__image">
                          {/* <img src={item.image} alt={item.name} /> */}
                        </div>
                      </div>

                      <p className="testimonial-card-two__quote">
                        {item.quote}
                      </p>

                      <div className="testimonial-card-two__bottom">
                        <div className="testimonial-card-two__identity">
                          <h4 className="testimonial-card-two__name">
                            {item.name}
                          </h4>
                          <p className="testimonial-card-two__designation">
                            {item.role}
                          </p>
                        </div>

                        {/* Star Ratings */}
                        <div className="lotus-ratings">
                          {[...Array(5)].map((_, i) => (
                            <span
                              key={i}
                              className="lotus-ratings__icon"
                            >
                              <i className="icon-star"></i>
                            </span>
                          ))}
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              ))}

            </Slider>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Testimonials;
